import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'auth-layout',
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss'],
    standalone: false
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  @Output() getRefferalCode = new EventEmitter(false)
  @Input() title : string
  @Input() subTitile : string
  @Input() type : string
  @Input() sideImage : string
  @Input() isHiddenImage : boolean
  @Input() hideHeader: boolean = false

  referalCode : string

  constructor(
    private router: Router,
    private activatedRoute : ActivatedRoute,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    // Add class to host element based on type for styling
    if (this.type === 'SIGNUP') {
      this.renderer.addClass(this.elementRef.nativeElement, 'signup-layout');
    }
    
    // Only prevent body scroll for login pages, allow scrolling for signup pages
    if (this.type !== 'SIGNUP') {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.height = '100vh';
    } else {
      // Allow scrolling for signup pages
      document.body.style.overflow = 'auto';
      document.body.style.height = 'auto';
      document.documentElement.style.overflow = 'auto';
      document.documentElement.style.height = 'auto';
    }
    
    this.activatedRoute.queryParams.subscribe((res)=>{
      if(res.refferalCode){
        localStorage.setItem("refferalCode",res.refferalCode )
        this.referalCode = res.refferalCode
       
      }
      this.generateReferal()
    })
    if(!this.referalCode && localStorage.getItem("refferalCode")){
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { referalCode: localStorage.getItem("refferalCode") },
        queryParamsHandling: 'merge', // <- This keeps existing query params and adds/updates the new one
      });
    }
  }
  
  ngOnDestroy(): void {
    // Restore body scroll when leaving auth layout
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
  }

  generateReferal(){
    if(this.referalCode){
      this.getRefferalCode.emit(this.referalCode)
    }
    else{
      this.getRefferalCode.emit(this.referalCode)
    }
  }
}
